import { render, staticRenderFns } from "./CartaoOrdemDePagamento.vue?vue&type=template&id=4cb7cbae&scoped=true"
import script from "./CartaoOrdemDePagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoOrdemDePagamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoOrdemDePagamento.vue?vue&type=style&index=0&id=4cb7cbae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7cbae",
  null
  
)

export default component.exports